export const paths = {
    home: '/',
    community: {
        challenges: '/community/posts',
    },
    auth: {
        signIn: '/login',
        signUp: '/sign-up',
        // registration: '/registration',
        signOut: '/sign-out',
    },
    store: '/store',
    writing: '/writing',
    search: '/search',
    mychannel: {
        default: '/mychannel',
        profile: '/mychannel/profile',
        settings: '/mychannel/settings',
        faq: '/mychannel/faq',
        announcements: '/mychannel/announcements',
    },
} as const;
